import type {
	ExistingInterview,
	ScheduleInterviewType,
} from '@/components/modal/Profile/scheduleInterview/types';
import type { DropdownItemColors } from '@/dsComponents/Dropdown/types';
import type { HistoryEntry } from '@/modules/companyNeed/types/history';

export enum MoveWorkerCompanyNeedCommands {
	SHOW = 'show',
	REFUSE = 'refuse',

	// colomns
	MOVE_TO_PREQUALIFIED = 'move-to-prequalified',
	MOVE_TO_CONTACTED = 'move-to-contacted',
	MOVE_TO_INTERVIEW = 'move-to-interview',
	MOVE_TO_COMPANY_PROPOSED = 'move-to-company-proposed',
	MOVE_TO_COMPANY_INTERVIEW = 'move-to-company-interview',
	MOVE_TO_MISSION_PROPOSED = 'move-to-mission-proposed',

	MOVE_TO_POOL = 'move-to-pool',
	ADD_TO_OTHER_POOLS = 'add-to-other-pools',
	MOVE_TO_ANOTHER_COMPANY_NEED = 'move-to-another-company-need',

	ADD_TO_ANOTHER_MISSION = 'add-to-another-mission',
	CREATE_NEW_MISSION_WITH_THIS_WORKER = 'create-new-mission-with-this-worker',
}

export const COMMANDS_REQUIRING_EMAIL: MoveWorkerCompanyNeedCommands[] = [
	MoveWorkerCompanyNeedCommands.MOVE_TO_INTERVIEW,
	MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_PROPOSED,
	MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_INTERVIEW,
	MoveWorkerCompanyNeedCommands.MOVE_TO_MISSION_PROPOSED,
	MoveWorkerCompanyNeedCommands.ADD_TO_ANOTHER_MISSION,
	MoveWorkerCompanyNeedCommands.CREATE_NEW_MISSION_WITH_THIS_WORKER,
];

export enum MoveWorkerModalView {
	MOVE = 'MOVE',
	MOVE_TO_ANOTHER_COMPANY_NEED = 'MOVE_TO_ANOTHER_COMPANY_NEED',
	MISSIONS = 'MISSIONS',
	COMPANY_NEEDS = 'COMPANY_NEEDS',
	ADD_TO_OTHER_POOLS = 'ADD_TO_OTHER_POOLS',
}

export interface BaseMoveWorkerCommand {
	key: string;
	label: string;
	icon: string;
	iconColor: string;
}

export interface MoveActionCommand extends BaseMoveWorkerCommand {
	key: MoveWorkerCompanyNeedCommands;
}

export interface MissionCommand extends BaseMoveWorkerCommand {
	startDate?: string;
	endDate?: string;
	fill: number;
	progressLabel: string;
}

export type MoveWorkerCommand = MoveActionCommand | MissionCommand;

export type MoveWorkerSections = MoveWorkerCommand[][];

export interface CurrentInterview {
	mode: ScheduleInterviewType;
	interview: ExistingInterview;
}

export interface MoveWorker {
	id: string;
	firstname: string;
	lastname: string;
	email?: string;
	phone?: string;
	picture?: string;
	fromJobOffer?: boolean;
	availableCommands?: MoveWorkerCompanyNeedCommands[];
	history?: HistoryEntry[];
	currentInterview?: CurrentInterview;
}

export interface MoveWorkerCompanyNeedModalProps {
	open: boolean;
	workers: MoveWorker[];
	companyNeedId?: string;
	companyId: string;
	isFromMatching?: boolean;
	isFromRecruitment?: boolean;
	fromJobOffer?: boolean;
	initialView?: MoveWorkerModalView;
	onSuccess?: (command?: MoveWorkerCompanyNeedCommands) => void | Promise<void>;
	onCancel?: () => void;
}

export interface MoveWorkerActionSubmenuItem {
	label: string;
	onClick: () => void;
}

export interface MoveWorkerActionItem {
	label: string;
	iconLeft?: string;
	iconLeftColor?: DropdownItemColors;
	labelColor?: DropdownItemColors;
	onClick?: () => void;
	hasSubmenu?: boolean;
	submenuItems?: MoveWorkerActionSubmenuItem[];
}
